module.exports = __webpack_public_path__ + "assets/img/0.6c78ef50.png";